import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceCreateAction from './machineServiceCreate.action.json' with { type: 'json' }
import { machineServiceCreateInputObject } from '../machineServiceObject'

const machineServiceCreateDefinition = defineAction({
  ...machineServiceCreateAction,

  input: machineServiceCreateInputObject,
  output: z.object({
    id: z.string().uuid(),
    code: z.number().int().positive(),
    protocolId: z.string().uuid(),
    protocolCode: z.number().int().positive(),
  }),
})

export default machineServiceCreateDefinition
